/**
 * Helper functions to get translated options for broker registration form
 * This allows us to use the i18n system with the constants
 */

import {
  INDUSTRIES,
  SPECIALIZED_INDUSTRIES,
  EXPERTISE_TYPES,
  EXPERIENCE_YEARS_OPTIONS,
  TRANSACTION_TYPES,
  EVALUATION_PROCESS_OPTIONS,
  NDA_ENFORCEMENT_OPTIONS,
  POST_SALE_ROLE_OPTIONS,
  POF_REQUIREMENT_OPTIONS,
  CASH_DOWN_PERCENT_OPTIONS,
  FIXED_AMOUNT_OPTIONS,
  FIXED_AMOUNT_MAX_OPTIONS,
  POF_DOCUMENT_TYPES,
  COMMUNICATION_STYLE_OPTIONS,
  COMPETING_OFFERS_OPTIONS,
  DEAL_SIZE_OPTIONS,
  FEE_STRUCTURE_OPTIONS,
} from '@/constants/broker-registration.constants';

type TranslationFunction = (key: string) => string;

export function getIndustryOptions(t: TranslationFunction) {
  return [...INDUSTRIES, ...SPECIALIZED_INDUSTRIES].map((industry) => ({
    value: industry.value,
    label: t(`broker_registration.options.industries.${industry.value}`),
  }));
}

export function getExpertiseOptions(t: TranslationFunction) {
  return EXPERTISE_TYPES.map((expertise) => ({
    value: expertise.value,
    label: t(`broker_registration.options.expertises.${expertise.value}`),
  }));
}

export function getExperienceYearsOptions(t: TranslationFunction) {
  return EXPERIENCE_YEARS_OPTIONS.map((exp) => ({
    value: exp.value,
    label: t(`broker_registration.options.experience_years.${exp.value}`),
  }));
}

export function getTransactionTypeOptions(t: TranslationFunction) {
  return TRANSACTION_TYPES.map((type) => ({
    value: type.value,
    label: t(`broker_registration.options.transaction_types.${type.value}`),
  }));
}

export function getEvaluationProcessOptions(t: TranslationFunction) {
  return EVALUATION_PROCESS_OPTIONS.map((option) => ({
    value: option.value,
    label: t(`broker_registration.options.evaluation_process.${option.value}`),
  }));
}

export function getNdaEnforcementOptions(t: TranslationFunction) {
  return NDA_ENFORCEMENT_OPTIONS.map((option) => ({
    value: option.value,
    label: t(`broker_registration.options.nda_enforcement.${option.value}`),
  }));
}

export function getPostSaleRoleOptions(t: TranslationFunction) {
  return POST_SALE_ROLE_OPTIONS.map((option) => ({
    value: option.value,
    label: t(`broker_registration.options.post_sale_role.${option.value}`),
  }));
}

export function getPofRequirementOptions(t: TranslationFunction) {
  return POF_REQUIREMENT_OPTIONS.map((option) => ({
    value: option.value,
    label: t(`broker_registration.options.pof_requirements.${option.value}`),
  }));
}

export function getCashDownPercentOptions(t: TranslationFunction) {
  return CASH_DOWN_PERCENT_OPTIONS.map((option) => ({
    value: option.value,
    label: t(`broker_registration.options.cash_down_percent.${option.value}`),
  }));
}

export function getFixedAmountMinOptions(t: TranslationFunction) {
  return FIXED_AMOUNT_OPTIONS.map((option) => ({
    value: option.value,
    label: t(`broker_registration.options.fixed_amounts.${option.value}`),
  }));
}

export function getFixedAmountMaxOptions(t: TranslationFunction) {
  return FIXED_AMOUNT_MAX_OPTIONS.map((option) => ({
    value: option.value,
    label: t(`broker_registration.options.fixed_amounts.${option.value}`),
  }));
}

export function getPofDocumentTypeOptions(t: TranslationFunction) {
  return POF_DOCUMENT_TYPES.map((option) => ({
    value: option.value,
    label: t(`broker_registration.options.pof_types.${option.value}`),
  }));
}

export function getCommunicationStyleOptions(t: TranslationFunction) {
  return COMMUNICATION_STYLE_OPTIONS.map((option) => ({
    value: option.value,
    label: t(`broker_registration.options.communication_style.${option.value}`),
  }));
}

export function getCompetingOffersOptions(t: TranslationFunction) {
  return COMPETING_OFFERS_OPTIONS.map((option) => ({
    value: option.value,
    label: t(`broker_registration.options.competing_offers.${option.value}`),
  }));
}

export function getDealSizeOptions(t: TranslationFunction) {
  return DEAL_SIZE_OPTIONS.map((option) => ({
    value: option.value,
    label: t(`broker_registration.options.deal_sizes.${option.value}`),
  }));
}

export function getFeeStructureOptions(t: TranslationFunction) {
  return FEE_STRUCTURE_OPTIONS.map((option) => ({
    value: option.value,
    label: t(`broker_registration.options.fee_structure.${option.value}`),
  }));
}
